var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 5,
    viewBox: "0 0 10 5",
    fill: "#C2CFE0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90601 0.228683C8.75867 0.0829141 8.55977 0.00115236 8.35251 0.00115236C8.14525 0.00115236 7.94635 0.0829141 7.79901 0.228683L4.98101 2.99768L2.19901 0.228683C2.12606 0.155996 2.03951 0.0983892 1.9443 0.059152C1.84909 0.0199147 1.74708 -0.000184442 1.6441 1.27535e-06C1.43612 0.000376348 1.23681 0.0833549 1.09001 0.230683C1.01732 0.303632 0.959718 0.390183 0.920481 0.485396C0.881243 0.580608 0.861144 0.682617 0.861329 0.785597C0.861704 0.993575 0.944683 1.19289 1.09201 1.33968L4.42001 4.65668C4.49313 4.73006 4.58001 4.78829 4.67568 4.82802C4.77135 4.86775 4.87392 4.8882 4.97751 4.8882C5.0811 4.8882 5.18367 4.86775 5.27934 4.82802C5.37501 4.78829 5.46189 4.73006 5.53501 4.65668L8.90601 1.33868C8.97963 1.26611 9.0381 1.17963 9.078 1.08427C9.1179 0.988904 9.13845 0.886559 9.13845 0.783182C9.13845 0.679806 9.1179 0.577461 9.078 0.482097C9.0381 0.386733 8.97963 0.300252 8.90601 0.227682V0.228683Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDown);
export default __webpack_public_path__ + "static/media/AngleDown.fc00d1e6.svg";
export { ForwardRef as ReactComponent };